import React from 'react';
import { FacebookIcon, InstagramIcon, LinkedinIcon, PhoneIcon, MailIcon, MapPinIcon } from 'lucide-react';
export function Footer() {
  const serviceLinks = ['Office Cleaning', 'Floor Care', 'Restroom Sanitation', 'Window Cleaning', 'Post-Construction', 'Janitorial'];
  const companyLinks = ['About Us', 'Careers', 'Blog', 'Contact'];
  return <footer className="bg-[#1A1A2E] text-white py-16 px-4 sm:px-6 lg:px-8" data-id="element-84">
      <div className="max-w-7xl mx-auto" data-id="element-85">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8" data-id="element-86">
          {/* Column 1 - Logo & Social */}
          <div className="text-center md:text-left" data-id="element-87">
            <h3 className="text-2xl font-bold mb-4" data-id="element-88">
              Bright & Clean Solutions
            </h3>
            <p className="text-gray-400 mb-6" data-id="element-89">
              Professional commercial cleaning you can count on.
            </p>
            <div className="flex justify-center md:justify-start gap-4" data-id="element-90">
              <a href="#" className="text-gray-400 hover:text-[#6BBF3B] transition-colors" aria-label="Facebook" data-id="element-91">
                <FacebookIcon className="w-6 h-6" data-id="element-92" />
              </a>
              <a href="#" className="text-gray-400 hover:text-[#6BBF3B] transition-colors" aria-label="Instagram" data-id="element-93">
                <InstagramIcon className="w-6 h-6" data-id="element-94" />
              </a>
              <a href="#" className="text-gray-400 hover:text-[#6BBF3B] transition-colors" aria-label="LinkedIn" data-id="element-95">
                <LinkedinIcon className="w-6 h-6" data-id="element-96" />
              </a>
            </div>
          </div>

          {/* Column 2 - Services */}
          <div className="text-center md:text-left" data-id="element-97">
            <h4 className="font-semibold text-lg mb-4" data-id="element-98">Services</h4>
            <ul className="space-y-2" data-id="element-99">
              {serviceLinks.map(link => <li key={link} data-id="element-100">
                  <a href="#services" className="text-gray-400 hover:text-white transition-colors" data-id="element-101">
                    {link}
                  </a>
                </li>)}
            </ul>
          </div>

          {/* Column 3 - Company */}
          <div className="text-center md:text-left" data-id="element-102">
            <h4 className="font-semibold text-lg mb-4" data-id="element-103">Company</h4>
            <ul className="space-y-2" data-id="element-104">
              {companyLinks.map(link => <li key={link} data-id="element-105">
                  <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-106">
                    {link}
                  </a>
                </li>)}
            </ul>
          </div>

          {/* Column 4 - Contact */}
          <div className="text-center md:text-left" data-id="element-107">
            <h4 className="font-semibold text-lg mb-4" data-id="element-108">Contact</h4>
            <ul className="space-y-3" data-id="element-109">
              <li className="flex items-center justify-center md:justify-start gap-3 text-gray-400" data-id="element-110">
                <PhoneIcon className="w-5 h-5 flex-shrink-0" data-id="element-111" />
                <span data-id="element-112">(555) 123-4567</span>
              </li>
              <li className="flex items-center justify-center md:justify-start gap-3 text-gray-400" data-id="element-113">
                <MailIcon className="w-5 h-5 flex-shrink-0" data-id="element-114" />
                <span data-id="element-115">info@brightandclean.com</span>
              </li>
              <li className="flex items-center justify-center md:justify-start gap-3 text-gray-400" data-id="element-116">
                <MapPinIcon className="w-5 h-5 flex-shrink-0" data-id="element-117" />
                <span data-id="element-118">Serving the Greater Metro Area</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 mt-12 pt-8 text-center" data-id="element-119">
          <p className="text-gray-500 text-sm" data-id="element-120">
            © 2026 Bright & Clean Solutions. All rights reserved.
          </p>
        </div>
      </div>
    </footer>;
}